/*
Usage :
const url = getUtmUrlWithParams('https://wpmudev.com/pricing/', {
  utm_campaign: 'homepage_banner',
  custom_param: 'value123'
});

Or simply :
const url = getUtmUrlWithParams('https://wpmudev.com/pricing/');
*/
export const getUtmUrl = (url, params = {}) => {
    const { utmSource = '' } = window.wpmudev_cross_sell_data || {};
  
    const defaultParams = {
      utm_source: utmSource,
      utm_medium: 'plugin',
      utm_campaign: 'cross-sell_top-cta',
      utm_content: 'plugins-cross-sell',
    };
  
    // Merge default params with any overrides
    const mergedParams = {
      ...defaultParams,
      ...params,
    };
  
    const urlObj = new URL(url);
  
    Object.entries(mergedParams).forEach(([key, value]) => {
      if (value != null) {
        urlObj.searchParams.set(key, value);
      }
    });
  
    return urlObj.toString();
  };
  
  